<template>
  <section class="layout">
    <section class="main-container">
      <section class="app-main">
        <transition name="fade-transform" mode="out-in">
          <router-view/>
        </transition>
      </section>
    </section>

    <van-tabbar v-model="active" v-show="this.$route.meta.hasFooter" active-color="#3cb8a2">
      <van-tabbar-item icon="home-o" to="/home">主页</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/mine">我的</van-tabbar-item>
    </van-tabbar>
  </section>
</template>

<script>
  const whiteList = ["/error"]
  export default {
    name: 'Layout',
    beforeRouteEnter(to, from, next) {
      if (whiteList.includes(to.path)) {
        next()
      }
      if (localStorage.getItem('token')) {
        next();
      } else {
        next({path: "/login"});
      }
    },
    data() {
      return {
        active: 0
      }
    },
    created() {
      this.$store.commit('SET_TOKEN', localStorage.getItem('token'));
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";

  .layout {

    .van-tabbar-item__icon .van-icon {
      transform: rotate(90deg);
    }
  }
</style>





// WEBPACK FOOTER //
// src/layout.vue